import { RefObject, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PlanEntitlementKey } from '../../../../../../../api/graphql/generated';
import {
  FeatureTourRef,
  FeatureTourStep,
} from '../../../../../../../components/feature/feature-tour';
import { PaywallSubscriptionDetail } from '../../../../../../../components/paywall/paywall';
import { useHasEntitlement } from '../../../../../../../components/plan/plan-entitlement-hooks';

const useFlowItemEnhancedStitchTourSteps = (
  tourRef: RefObject<FeatureTourRef>
): FeatureTourStep[] => {
  const { i18n } = useTranslation();
  const hasWeldingEnhancedStitch = useHasEntitlement(
    PlanEntitlementKey.WELDING_ENHANCED_STITCH
  );

  const tour = useMemo(() => {
    const inputsSelector = 'enhanced-stitch-inputs';
    const lengthLockSelector = 'enhanced-stitch-length-lock';

    const steps: FeatureTourStep[] = [
      {
        analyticKey: 'enhanced_stitch_inputs_info',
        selector: inputsSelector,
        title: i18n.t('common:enhanced_stitch'),
        description: i18n.t('welding:enhanced_stitch_tour_inputs_description'),
        position: {
          side: 'bottom',
          alignment: 'center',
        },
      },
      {
        analyticKey: 'enhanced_stitch_lock_info',
        selector: lengthLockSelector,
        title: i18n.t('common:enhanced_stitch'),
        description: (
          <>
            {i18n.t('welding:enhanced_stitch_tour_lock_choice_description')}
            <br />
            <br />
            {i18n.t('welding:enhanced_stitch_tour_lock_both_description')}
          </>
        ),
        position: {
          side: 'bottom',
          alignment: 'center',
        },
        disableHighlight: true,
      },
    ];

    if (!hasWeldingEnhancedStitch) {
      steps.push({
        analyticKey: 'enhanced_stitch_subscription',
        selector: inputsSelector,
        title: i18n.t('common:enhanced_stitch'),
        description: (
          <PaywallSubscriptionDetail
            planEntitlementKey={PlanEntitlementKey.WELDING_ENHANCED_STITCH}
            onBeforeNavigate={() => {
              tourRef.current?.stopTour();
            }}
          />
        ),
        position: {
          side: 'bottom',
          alignment: 'center',
        },
      });
    }

    return steps;
  }, [hasWeldingEnhancedStitch, i18n, tourRef]);

  return tour;
};

export { useFlowItemEnhancedStitchTourSteps };
